const scrollIndicator = require('./scrollIndicator.module');
UX.scrollIndicator = scrollIndicator;
